/**
 * A small piece of product UI shown inline on small screens; large screens see it
 * on the sticky stage. The product UI is dark in both themes, so this carries `dark`.
 */
export function InlinePiece({ children }: { children: React.ReactNode }) {
  return (
    <div className="dark mt-6 h-[176px] overflow-hidden rounded-lg border border-border bg-background text-foreground lg:hidden">
      {children}
    </div>
  )
}
